// @ts-nocheck



import React from 'react';


import { budgetSummaryApi } from './../../lib/api';

import { budgetSummaryInfoString } from '../../lib/helpers';

import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) => {
  return (
    <AutocompleteSelect
      fetch={async (params) => {
        return await budgetSummaryApi.fetch({
          ...params,
          ...filter
        });
      }}
      refetchParams={{ filter }}
      fetchSingle={budgetSummaryApi.get}
      notFoundText="Бюджеты не найдены"
      placeholder="Выберите сводный бюджет"
      renderOption={(budgetSummary, Option) =>
      <Option
        key={budgetSummary.id}
        value={budgetSummary.id}
        vehiclePlan={budgetSummary}>

          {budgetSummaryInfoString(budgetSummary)}
        </Option>
      }
      {...selectProps} />);


};
